//@flow
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import SearchInput from '../SearchInput';

type Props = {|
  placeholder?: string,
  onSearch?: (searchTerm: string) => void,
  className?: string,
|};

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 200,
    maxWidth: 400,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      minWidth: 150,
      maxWidth: 250,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 120,
      maxWidth: 200,
    },
  },
}));

export default function HeaderSearchBar(props: Props) {
  const {placeholder = 'Buscar...', onSearch, className} = props;
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (value: string) => {
    setSearchValue(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleClear = () => {
    setSearchValue('');
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <SearchInput
      className={`${classes.root} ${className || ''}`}
      placeholder={placeholder}
      value={searchValue}
      onChange={setSearchValue}
      onSubmit={handleSearch}
      onClear={handleClear}
      fullWidth
    />
  );
}

HeaderSearchBar.propTypes = {
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
  className: PropTypes.string,
};
